import React, { useEffect } from 'react'
import { match_hotkey } from '../functions/match_hotkeys';
import { Hotkey } from '../types/hotkey';
import { Controls, ControlSymbol, KeySymbol, Symbol } from '../types/symbol';
import { useKeyDownEvent } from './use_key_down_event';

export const useKeyProcessor = (hotkeys: Array<Hotkey>, process: (symbol: Symbol) => void) => {
	useKeyDownEvent((event: KeyboardEvent) => {
		let metas: Array<String> = [];
		if (event.ctrlKey)
			metas.push('ctrl')
		if (event.metaKey)
			metas.push('meta')
        if (event.key === " ") {
            event.preventDefault()
        }
        
		if (process_key(event.key, metas)) {
			event.preventDefault()
		}
	})
	const process_key = (key: String, metas: Array<String>) => {
		const hotkey = match_hotkey(key, metas, hotkeys);
		if (hotkey) {
			hotkey.action()
			return true;
		} else if (metas.length === 0) {
			let symbol = key_to_symbol(key)
			if (symbol) {
                process(symbol)
                return true
            }
		}
        return false
	}
}

const key_to_symbol = (key: String) => {
    let map: Map<String, Symbol> = new Map<String, Symbol>(
        [
            ['Enter', new KeySymbol('\n')],
            ['Tab', new KeySymbol('\t')],
            ['Backspace', new ControlSymbol(Controls.Delete)],
        ]
    )
    const symbol = map.get(key)
    if (symbol) {
        return symbol
    } else if (key.length === 1) {
        return new KeySymbol(key)
    } else {
        return null
    }
}